import { Mail, MapPin, Phone, Clock } from "lucide-react";
import { ContactForm } from "@/components/site/ContactForm";
import { BUSINESS } from "@/lib/site";

const Contact = () => {
  return (
    <div data-testid="page-contact">
      <section className="bg-[var(--bg-secondary)] wave-divider">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 pt-20 pb-12">
          <p className="eyebrow">Get in touch</p>
          <h1 className="mt-3 font-display text-4xl sm:text-5xl lg:text-6xl text-[var(--ink)] tracking-tight leading-[1.05]">
            Reach out — let’s chat coverage.
          </h1>
          <p className="mt-5 max-w-2xl text-base sm:text-lg text-slate-700 leading-relaxed">
            Pick whichever channel works best. Christian responds personally,
            usually within a few hours during business hours.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-5 sm:px-8 py-20 grid grid-cols-1 lg:grid-cols-3 gap-10">
        <div className="space-y-5">
          <div className="rounded-2xl border border-slate-200 bg-white p-6">
            <div className="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-[var(--bg-secondary)] text-[var(--brand-primary)]">
              <Phone className="w-5 h-5" />
            </div>
            <p className="mt-4 eyebrow">Call or text</p>
            <a
              href={`tel:${BUSINESS.phoneRaw}`}
              data-testid="contact-phone-link"
              className="mt-2 block font-display text-2xl text-[var(--ink)] hover:text-[var(--brand-primary)] transition-colors"
            >
              {BUSINESS.phone}
            </a>
          </div>
          <div className="rounded-2xl border border-slate-200 bg-white p-6">
            <div className="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-[var(--bg-secondary)] text-[var(--brand-primary)]">
              <Mail className="w-5 h-5" />
            </div>
            <p className="mt-4 eyebrow">Email</p>
            <a
              href={`mailto:${BUSINESS.email}`}
              data-testid="contact-email-link"
              className="mt-2 block font-display text-lg text-[var(--ink)] hover:text-[var(--brand-primary)] transition-colors break-all"
            >
              {BUSINESS.email}
            </a>
          </div>
          <div className="rounded-2xl border border-slate-200 bg-white p-6">
            <div className="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-[var(--bg-secondary)] text-[var(--brand-primary)]">
              <MapPin className="w-5 h-5" />
            </div>
            <p className="mt-4 eyebrow">Office</p>
            <p className="mt-2 text-[var(--ink)] leading-relaxed">{BUSINESS.address}</p>
          </div>
          <div className="rounded-2xl border border-slate-200 bg-white p-6">
            <div className="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-[var(--bg-secondary)] text-[var(--brand-primary)]">
              <Clock className="w-5 h-5" />
            </div>
            <p className="mt-4 eyebrow">Hours</p>
            <p className="mt-2 text-[var(--ink)]">{BUSINESS.hours}</p>
            <p className="mt-1 text-sm text-slate-500">{BUSINESS.experience}</p>
          </div>
        </div>

        <div className="lg:col-span-2">
          <ContactForm />
        </div>
      </section>
    </div>
  );
};

export default Contact;
